var map = {
	"./Momo.webp": 57828,
	"./佛印.webp": 22391,
	"./刮骨療傷的關羽.webp": 86728,
	"./劉備.webp": 80134,
	"./南極仙翁.webp": 52798,
	"./唐太宗.webp": 68975,
	"./唐明皇.webp": 5619,
	"./圍棋仕女嘉嘉.webp": 6006,
	"./孫悟空.webp": 39652,
	"./孫權.webp": 60777,
	"./小嘉嘉.webp": 25579,
	"./小龍公主.webp": 9837,
	"./帥林老師.webp": 36980,
	"./張飛.webp": 91608,
	"./德川家康.webp": 21315,
	"./曹操.webp": 6826,
	"./楊貴妃.webp": 211,
	"./溫柔的嘉嘉老師.webp": 7507,
	"./牛魔王.webp": 8456,
	"./白居易.webp": 44715,
	"./目標成為職業的8歲嘉嘉.webp": 96089,
	"./織田信長.webp": 47644,
	"./蕭正浩.webp": 92059,
	"./蘇東坡.webp": 36067,
	"./許皓鋐.webp": 45892,
	"./謝依旻.webp": 39307,
	"./豐臣秀吉.webp": 93510,
	"./貴妃的狗.webp": 84464,
	"./采潔.webp": 31527,
	"./鐵扇公主.webp": 13477,
	"./關羽.webp": 75359,
	"./鬥戰勝佛.webp": 71177,
	"./黑嘉嘉.webp": 29029,
	"./齊天大聖.webp": 276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16607;